function customFormatMoney(cents) {
  return new Intl.NumberFormat("en-PH", {
    style: "currency",
    currency: "PHP",
    minimumFractionDigits: 0,
  }).format(cents / 100);
}

function customFetchCart() {
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const cartItemsEl = document.getElementById("custom-slide-cart-items");
      const emptyMsgEl = document.getElementById("custom-slide-cart-empty-message");
      const subtotalEl = document.getElementById("custom-cart-subtotal");
      const summarySection = document.querySelector(".custom-slide-cart__summary");
      const checkoutButton = document.getElementById("custom-slide-cart-checkout");
      const heartIcon = document.getElementById("custom-icon-heart")?.innerHTML || "♡";
      const trashIcon = document.getElementById("custom-icon-trash")?.innerHTML || "🗑️";

      

      if (cart.items.length > 0) {
        const html = cart.items
          .map(
            (item) => {
              const variantOptions = item.options_with_values
                .filter(opt => opt.value !== 'Default Title')
                .map(opt => { return `${opt.value}`; })
                .join(', ');

              return `<div class="custom-slide-cart__item">
          <div class="custom-slide-cart__img">
            <img src="${item.image}" alt="${item.product_title}" />
          </div>
          <div class="custom-slide-cart__details">
            <div class="custom-slide-cart__info">
              <div class="custom-slide-cart__info-row"> 
                <h4 class="custom-slide-cart__product-title">${item.product_title}</h4>
                <h4 class="custom-slide-cart__product-price">${customFormatMoney(item.final_line_price)}</h4>
              </div>
              <div class="custom-slide-cart__info-col">
                <h4 class="custom-slide-cart__info-variant">${variantOptions}</h4>
              </div>
            </div>
            <div class="custom-slide-cart__product-actions">
              <div class="custom-qty-controls" data-line="${item.key}">
                <button class="custom-qty-minus">−</button>
                <input type="text" value="${item.quantity}" readonly />
                <button class="custom-qty-plus">+</button>
              </div>
              <div class="custom-slide-cart__buttons">
                <button class="custom-wishlist">${heartIcon}</button>
                <button class="custom-remove" data-key="${item.key}">${trashIcon}</button>
              </div>
            </div>
          </div>
        </div>
      `}
          )
          .join("");
        cartItemsEl.style.display = "flex";
        cartItemsEl.innerHTML = html;
        emptyMsgEl.style.display = "none";
        summarySection.style.display = "flex";
        checkoutButton.style.display = "inline-block";
        subtotalEl.textContent = customFormatMoney(cart.items_subtotal_price);

      } else {

        summarySection.style.display = "none";
        checkoutButton.style.display = "none";
        cartItemsEl.innerHTML = `
        <div id="custom-slide-cart-empty-message" class="custom-slide-cart__empty-message">
          <h4 class="medium">Your Cart is empty</h4>
          <h4>Looks like you haven’t added anything yet. Start shopping to fill your cart!</h4>
        </div>`;
        cartItemsEl.style.display = "none";
        emptyMsgEl.style.display = "flex";
      }
    });
}

function customOpenSlideCart() {
  document
    .getElementById("custom-slide-cart")
    .classList.remove("custom-hidden");
  customFetchCart();
  renderRecentlyViewedSlider();
}

function customCloseSlideCart() {
  document.getElementById("custom-slide-cart").classList.add("custom-hidden");
}

document.querySelectorAll("[data-open-slide-cart]").forEach((btn) => {
  btn.addEventListener("click", customOpenSlideCart);
});

document
  .getElementById("custom-slide-cart-close-icon")
  .addEventListener("click", customCloseSlideCart);
document
  .getElementById("custom-slide-cart-overlay")
  .addEventListener("click", customCloseSlideCart);
document
  .getElementById("custom-slide-cart-continue")
  .addEventListener("click", customCloseSlideCart);
// Delegated events
document.addEventListener("click", function (e) {
  if (e.target.matches(".custom-qty-plus, .custom-qty-minus")) {
    const qtyControls = e.target.closest(".custom-qty-controls");
    const input = qtyControls.querySelector("input");

    if (!input) return; // safety check

    const key = qtyControls.dataset.line;
    let qty = parseInt(input.value);

    qty += e.target.classList.contains("custom-qty-plus") ? 1 : -1;
    qty = qty < 1 ? 1 : qty;

    customUpdateCartItem(key, qty);
  }

  const removeBtn = e.target.closest(".custom-remove");
  if (removeBtn) {
    const key = removeBtn.dataset.key;
    console.log("Removing item with key:", key);
    customUpdateCartItem(key, 0);
  }
});

function customUpdateCartItem(lineKey, quantity) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: lineKey, quantity }),
  }).then(customFetchCart);
}

document.querySelectorAll("[data-open-slide-cart]").forEach((btn) => {
  btn.addEventListener("click", function (e) {
    e.preventDefault(); // prevent going to the link
    customOpenSlideCart();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  customFetchCart();
});

document.addEventListener('click', function (e) {
  const quickAddButton = e.target.closest('[data-quick-add]');

  if (quickAddButton) {
    e.preventDefault();

    const container = quickAddButton.closest('.custom-product__quick-actions-button-container');
    const idInput = container.querySelector('input[name="id"]');
    const availableQty = parseInt(container.dataset.available, 10);

    if (!idInput) {
      console.error('No variant ID found for quick add');
      return;
    }

    const variantId = idInput.value;

    // Fetch current cart first
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        // Find if this variant already exists in cart
        const existingItem = cart.items.find(item => item.id == variantId);
        const currentQty = existingItem ? existingItem.quantity : 0;

        // Check if adding one more exceeds available
        if (currentQty + 1 > availableQty) {
          alert('Cannot add more, stock limit reached.');
          return;
        }

        // Safe to add!
        const formData = new FormData();
        formData.append('id', variantId);

        return fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
      })
      .then(res => {
        if (res && !res.ok) {
          throw new Error('Failed to add item to cart');
        }
        if (res) {
          return res.json();
        }
      })
      .then(data => {
        customFetchCart();
        customOpenSlideCart();
      })
      .catch(error => {
        console.error(error);
        alert('Sorry, something went wrong adding to cart.');
      });
  }
});

function renderRecentlyViewedSlider() {
  const viewed = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
  const container = document.getElementById('custom-recently-viewed-cards');
  const bar = document.getElementById('custom-progress-bar');
  const wrapper = container.closest('.custom-slide-cart__recently-viewed');

  if (!viewed || viewed.length < 1) {
    wrapper.style.display = 'none';
    return;
  }

  const cards = viewed.slice(0, 3).map(product => `
    <a href="${product.url}" class="custom-card">
      <div class="custom-card__image">
        <img src="${product.image}" alt="${product.title}">
      </div>
      <div class="custom-card__title">${product.title}</div>
      <div class="custom-card__price">${product.price || ''}</div>
    </a>
  `).join('');

  container.innerHTML = cards;
  wrapper.style.display = 'block';

  // Update progress bar width
  const progressPercent = (viewed.length >= 3 ? 3 : viewed.length) / 3 * 100;
  bar.style.width = `${progressPercent}%`;
}